var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.7255,46.87538c-0.91106,-3.87 -3.81894,-6.97406 -7.70237,-8.20494c-10.29044,-3.26531 -32.6155,-6.42044 -58.02313,-6.42044c-25.40763,0 -47.73269,3.15512 -58.02581,6.42044c-3.88344,1.23087 -6.79131,4.33494 -7.70237,8.20494c-1.72,7.30731 -4.14681,20.85769 -4.14681,39.12463c0,18.26694 2.42681,31.81731 4.1495,39.12462c0.91106,3.87 3.81894,6.97406 7.70238,8.20494c10.29044,3.26531 32.6155,6.42044 58.02313,6.42044c25.40762,0 47.73269,-3.15512 58.02581,-6.42044c3.88344,-1.23087 6.79131,-4.33494 7.70237,-8.20494c1.72,-7.30731 4.14681,-20.85769 4.14681,-39.12462c0,-18.26694 -2.42681,-31.81731 -4.1495,-39.12462zM72.5625,107.5v-43l39.92819,21.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c12cadeb9b7c5807bc5db1e56057df9c.svg";
export { ForwardRef as ReactComponent };